/* eslint-disable no-undef */
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as eventActions from "../../actions/eventActions";
import { Col, Row, Modal, Container, Form, Button } from "react-bootstrap";
import { Link, useParams } from "react-router-dom";
import moment from "moment";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useForm } from "react-hook-form";
import { decode } from "html-entities";
import { imgPath } from "../../utils/imagePath";
import PopupModalWithOk from "../../utils/helpers/popupModalOk";
import PropTypes from "prop-types";

const Index = (props) => {
  const { actions, eventsData } = props;
  const { type: event_type } = useParams();
  const [getSlug, setGetSlug] = useState("");
  const [show, setShow] = useState(false);
  const [showOrganization, setShowOrganization] = useState(false);
  const [getLoader, setGetLoader] = useState(false);
  const { register, handleSubmit, reset, formState: { errors } } = useForm({ mode: "onChange" });

  const [popupMessage, setPopupMessage] = useState("");
  const [showPopup, setShowPopup] = useState(false);

  const handleClose = () => {
    reset();
    setShow(false);
  };

  const handleEventShow = (e, slug) => {
    setGetSlug(slug);

    // Reset form values when opening modal
    reset({
      full_name: "",
      email: "",
      user_type: "",
      organization: "",
      subscribe_to_newsletter: true,
      slug: slug
    });

    setShow(true);
  };

  useEffect(() => {
    const fetchData = () => {
      actions.loadEventData(event_type);
    };
    fetchData();
  }, [event_type]);

  const onSubmit = async (data) => {
    setGetLoader(true);
    const request = {};

    if (!!data.full_name && !!data.email) {
      request.full_name = data.full_name;
      request.email = data.email;
      request.user_type = data.user_type;
      request.subscribe_to_newsletter = data.subscribe_to_newsletter ? 'Yes' : 'No';
      if (data?.organization) {
        request.organisation = data?.organization;
      }
      request.slug = data.slug;

      const result = await actions.handleSubmitRSVP(request, setShow, setGetLoader);

      // Handle popup here instead of Redux
      if (result?.status === 200) {
        setPopupMessage(result?.message);
        setShowPopup(true);
      } else {
        setPopupMessage(result?.message || "Something went wrong, please try again.");
        setShowPopup(true);
      }
    }
  };

  const handleRSVPPopupClose = () => {
    setShowPopup(false);
    setShow(false);     // close RSVP modal
    reset();            // reset form
  };

  const loadCalendarScript = () => {
    if (globalThis.addeventatc) {
      globalThis.addeventatc.refresh();
      return;
    }
    // SonarQube Security Hotspot reviewed:
    // This script is loaded from a trusted third-party (addevent.com).
    // The library does not provide a fixed version or SRI hash.
    // Risk is accepted as functionality depends on this external service.
    const script = document.createElement("script");
    script.src = "https://cdn.addevent.com/libs/atc/1.6.1/atc.min.js";
    script.integrity = "sha384-37SPFKb8nmPyX31cN+eOIXlahABEhfrs0GWG4ElwAVV7uqqHfwwLWMBi7fXu4WGU";
    script.crossOrigin = "anonymous";
    script.async = true;
    script.onload = () => {
      console.log("Calendar script loaded");
    };

    document.body.appendChild(script);
  };

  useEffect(() => {
    if (eventsData && eventsData.length > 0) {
      setTimeout(() => {
        loadCalendarScript();
      }, 100);
    }
  }, [eventsData]);

  return (
    <>
      <section className="outer_main about_page page-content event-page">
        <h1 className=" text-center" style={{ fontSize: '24px', fontWeight: '600', marginBottom: 10 }}>Events </h1>
        <Container>
          <div className="event-wrapper">
            <div className="event-tabs-wr">
              <Link
                to="/event/upcoming"
                className={
                  event_type === "upcoming" ? "active event-tabs" : "event-tabs"
                }
              >
                Upcoming Events
              </Link>
              <Link
                to="/event/past"
                className={
                  event_type === "past" ? "active event-tabs" : "event-tabs"
                }
              >
                Past Events
              </Link>
            </div>

            <Row className="events_listing-outer">
              {eventsData && eventsData.length > 0 ? (
                eventsData.map((item, key) => (
                  <Col lg={4} md={6} key={item.id}>
                    <div className="event_listing verticle_grid">
                      {item.image && (
                        <Link to={"/event-detail/" + item.slug}>
                          <figure>
                            <img src={item.image} alt={item.title} />
                          </figure>
                        </Link>
                      )}
                      <div className="list_info">
                        {item.title && (
                          <h3>
                            <Link
                              style={{ fontWeight: "800" }}
                              to={"/event-detail/" + item.slug}
                            >
                              {item.title}
                            </Link>
                          </h3>
                        )}
                        {item.publish_date && (
                          <span className="date">
                            <img src={imgPath + "time.svg"} alt="time" />
                            {`${moment(new Date(item?.publish_date)).format(
                              "Do MMM YY"
                            )} ${item?.calender_start_date?.split("+")[1]} ${item?.calender_start_date?.split("+")[2]
                              } - ${item?.calender_end_date?.split("+")[1]} ${item?.calender_end_date?.split("+")[2]
                              } ${item?.timezone}`}
                          </span>
                        )}
                        {item.address && (
                          <span className="locationfix" style={{
                            wordBreak: 'break-word',
                          }}>
                            <img src={imgPath + "location.svg"} alt="location" />
                            {item.address}
                          </span>
                        )}

                        {event_type === "upcoming" && (
                          <>
                            <div
                              title="Add to Calendar"
                              className="addeventatc mt-3" style={{ visibility: "visible" }}
                            >
                              <i className="fa fa-plus"></i> Calendar{" "}
                              <span className="start">{item.start_date}</span>{""}
                              <span className="end">
                                {item.end_date
                                  ? item.end_date
                                  : item.start_date}
                              </span>{""}
                              <span className="timezone">{item.timezone}</span>{""}
                              <span className="title">{item.title}</span>{""}
                              <span className="description">
                                {decode(item.addevent_description, {
                                  level: "html5",
                                })}
                              </span>{""}
                              <span className="description">{decode(item.short_description + '<br><br>For more details view this ' + globalThis.origin + "/event-detail/" + item.slug, { level: 'html5' })}</span>{""}
                              <span className="location">{item.address}</span>
                            </div>
                            <button
                              onClick={(e) => {
                                handleEventShow(e, item.slug);
                              }}
                              className="ms-auto btn btn_login outline_btn btn_white rsvp_btn"
                            >
                              RSVP
                            </button>
                          </>
                        )}

                        {!!item.short_description && (
                          <p style={{
                            wordBreak: 'break-word',
                          }}>{item?.short_description?.substring(0, 150)}</p>
                        )}
                        <Link
                          to={"/event-detail/" + item.slug}
                          className="readMoreUp"
                        >
                          Read more
                        </Link>
                      </div>
                    </div>
                  </Col>
                ))
              ) : (
                <h3 className="m-auto">We are working on few exciting events and will post details soon. Check out our past events</h3>
              )}
            </Row>
          </div>
        </Container>

        <Modal show={show} onHide={handleClose} className="rsvp_modal calendar-modal" centered>
          <Modal.Header closeButton>RSVP </Modal.Header>
          <Modal.Body className="arrow_icon thumbnail">
            <Form onSubmit={handleSubmit(onSubmit)}>
              <Form.Group controlId="rsvp_full_name" className="mb-3">
                <Form.Label>Name*</Form.Label>
                <Form.Control
                  type="text"
                  className="form-control"
                  {...register("full_name", {
                    minLength: 3,
                    required: true,
                    maxLength: 50,
                  })}
                  name="full_name"
                />
              </Form.Group>
              {errors.full_name &&
                errors.full_name?.type === "required" && (
                  <label className="text-left" style={{ color: '#dc3545', fontSize: '0.875em', marginTop: '0.25rem' }} htmlFor="rsvp_full_name">
                    Please enter Name
                  </label>
                )}
              {errors.full_name &&
                errors.full_name?.type === "minLength" && (
                  <label className="text-left" style={{ color: '#dc3545', fontSize: '0.875em', marginTop: '0.25rem' }} htmlFor="rsvp_full_name">
                    Minimum length should be 3
                  </label>
                )}
              {errors.full_name && errors.full_name?.type === "maxLength" && (
                <span role="alert" className="err_msg" style={{ color: '#dc3545', fontSize: '0.875em', marginTop: '0.25rem' }}>
                  Your name should contain max 50 characters
                </span>
              )}
              <Form.Group controlId="rsvp_email" className="mb-3">
                <Form.Label>Email*</Form.Label>
                <Form.Control
                  type="text"
                  className="form-control"
                  {...register("email", {
                    required: true,
                    pattern: {
                      value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                    },
                    maxLength: 50,
                  })}
                  name="email"
                />
              </Form.Group>
              {errors.email && errors.email?.type === "required" && (
                <span role="alert" className="err_msg" style={{ color: '#dc3545', fontSize: '0.875em', marginTop: '0.25rem' }}>
                  Please enter your email address
                </span>
              )}
              {errors.email && errors.email?.type === "pattern" && (
                <span role="alert" className="err_msg" style={{ color: '#dc3545', fontSize: '0.875em', marginTop: '0.25rem' }}>
                  Invalid email address
                </span>
              )}
              {errors.email && errors.email?.type === "maxLength" && (
                <span role="alert" className="err_msg" style={{ color: '#dc3545', fontSize: '0.875em', marginTop: '0.25rem' }}>
                  Your email should contain max 50 characters
                </span>
              )}
              <Form.Group controlId="rsvp_user_type" className="mb-3">
                <Form.Label>Are you a vLookUp user?*</Form.Label>
                <Form.Control
                  as="select"
                  className="mb-3"
                  name="user_type"
                  // ref={register({
                  {...register("user_type", {
                    required: true,
                  })}
                  onChange={(e) => {
                    e.target.value === 'None' ? setShowOrganization(true) : setShowOrganization(false);
                  }}
                >
                  <option value="">Please select the category</option>
                  <option value="None">No</option>
                  <option value="Mentee">Mentee</option>
                  <option value="Mentor">Mentor</option>
                </Form.Control>
                {errors.user_type && errors.user_type?.type === "required" && (
                  <span role="alert" className="err_msg" style={{ color: '#dc3545', fontSize: '0.875em', marginTop: '0.25rem' }}>
                    Please select category
                  </span>
                )}
                {showOrganization && <Form.Group controlId="rsvp_organization" className="mb-3">
                  <Form.Label>Organization*</Form.Label>
                  <Form.Control
                    type="text"
                    className="form-control"
                    maxLength={150}
                    {...register("organization", {
                      minLength: 3,
                      required: true,
                      maxLength: 150,
                      validate: {
                        whiteSpace: (value) =>
                          value.trim() ? true : "White spaces not allowed.",
                      },
                    })}
                    name="organization"
                  />
                </Form.Group>}
                {errors?.organization &&
                  errors?.organization?.type === "whiteSpace" && (
                    <label style={{ color: '#dc3545', fontSize: '0.875em', marginTop: '0.25rem' }} htmlFor="organization">
                      Whitespace not allowed
                    </label>
                  )}
                {errors.organization &&
                  errors.organization?.type === "required" && (
                    <label className="text-left" style={{ color: '#dc3545', fontSize: '0.875em', marginTop: '0.25rem' }} htmlFor="rsvp_organization">
                      Please enter Organization
                    </label>
                  )}
                {errors.organization &&
                  errors.organization?.type === "minLength" && (
                    <label className="text-left" style={{ color: '#dc3545', fontSize: '0.875em', marginTop: '0.25rem' }} htmlFor="rsvp_organization">
                      Minimum length should be 3
                    </label>
                  )}
                {errors.organization && errors.organization?.type === "maxLength" && (
                  <span role="alert" className="err_msg" style={{ color: '#dc3545', fontSize: '0.875em', marginTop: '0.25rem' }}>
                    Organization name should contain max 50 characters
                  </span>
                )}

                <Form.Group controlId="rsvp_organization" className="mb-3">
                  <span className="custom_check">
                    Subscribe to our newsletter to stay updated {""}
                    <input
                      name='subscribe_to_newsletter'
                      type="checkbox"
                      defaultChecked={true}
                      {...register("subscribe_to_newsletter", {
                      })}
                    ></input>{""}
                    <span className="check_indicator">&nbsp;</span>
                  </span>
                </Form.Group>

                <Form.Control
                  type="hidden"
                  defaultValue={getSlug}
                  {...register("slug")}
                  name="slug"
                />
              </Form.Group>
              <Button
                type="submit"
                className="btn btn_submit ml-2"
                align="center"
                disabled={getLoader}
              >
                {getLoader ? "Submitting.." : "Submit"}
              </Button>
            </Form>
          </Modal.Body>
        </Modal>
      </section>

      <PopupModalWithOk
        show={showPopup}
        onHide={handleRSVPPopupClose}
        message={popupMessage}
        showConfirm={false}
        staticBackdrop={true}
      />

    </>
  );
};

Index.propTypes = {
  eventsData: PropTypes.shape({
    length: PropTypes.number,
    map: PropTypes.func,
  }).isRequired,
  userdata: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  }).isRequired,
  actions: PropTypes.shape({
    loadEventData: PropTypes.func.isRequired,
    handleSubmitRSVP: PropTypes.func.isRequired,
  }).isRequired,
};

function mapStateToProps(state) {
  return {
    eventsData: state.eventsData,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      { ...eventActions },
      dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Index);
